import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { HelpSearchItem, HelpSuggestionClickHandler } from '../../../model';
import { SEARCH_TEST_ID } from '../../../test/test-ids';
import { getFullUrl } from '../../../utils/paths';
import { ContentCard } from '../../ContentCard/ContentCard';
import { SectionHeading, SuggestionsCardsWrapper } from '../SearchSuggestions.styles';

type Props = {
    helpItems: HelpSearchItem[];
    onClick?: HelpSuggestionClickHandler;
};

const SEARCH_SUGGESTIONS_HELP = 'search-suggestions-help';

export const HelpSuggestions: FC<Props> = ({ helpItems, onClick }) => {
    const { t } = useTranslations();

    return (
        <section data-test={SEARCH_TEST_ID.SUGGESTIONS_HELP} aria-labelledby={SEARCH_SUGGESTIONS_HELP}>
            <SectionHeading tag="h2" variant="title-100" id={SEARCH_SUGGESTIONS_HELP}>
                {t['search.suggestions.help.title']}
            </SectionHeading>
            <SuggestionsCardsWrapper>
                {helpItems.map((helpItem) => {
                    const splitCategories = helpItem.categories?.split(' > ');

                    return (
                        <ContentCard
                            key={helpItem.id}
                            title={helpItem.title}
                            categoryLevel1={splitCategories?.[0]}
                            categoryLevel2={splitCategories?.[1]}
                            url={getFullUrl(helpItem.url)}
                            onClick={(event) => onClick?.(helpItem, event)}
                        />
                    );
                })}
            </SuggestionsCardsWrapper>
        </section>
    );
};
